import React from 'react';
import { Box } from '@mui/material';
import { useComponentOverrides } from 'c-wrapper/Components/CommonWrapper/CommonWrapper';
import { useSelector } from 'react-redux';
import { uiSelectors } from 'c-wrapper/Slices/UI';
import { drawerWidth } from 'c-wrapper/constants';

const IconTopBarBrandLogo: React.FC = () => {
    const { MiniBrandLogo } = useComponentOverrides();
    const isDrawerOpen = useSelector(uiSelectors.isDrawerOpen);
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                height: 36,
                flexShrink: 0,
                width: 'auto',
                maxWidth: isDrawerOpen ? drawerWidth - 100 : 'none',
                '& svg, & img': { height: '100%', width: 'auto', maxWidth: 'none' },
            }}
        >
            {MiniBrandLogo}
        </Box>
    );
};

export default IconTopBarBrandLogo;
